import React from 'react'
import Layout from './Master'
import { graphql } from 'gatsby'
import renderHTML from 'react-render-html'
import { Box, Heading } from 'rebass/styled-components'
import Featured from '../modules/Featured'
import Feed from '../modules/Feed'

const PostDetails = ({ data }) => {
    const { post } = data
    return (
        <>
            {post && (
                <Layout>
                    <Featured
                        options={{
                            backgroundColor: 'greyLight',
                            media: post.media,
                            title: (
                                <Box
                                    as='span'
                                    sx={{ color: '#e96338' }}
                                >
                                    {post.title}
                                </Box>
                            ),
                            content: '',
                            carousel: true,
                        }}
                    />
                    <Box
                        bg='white'
                        mt='sm'
                        mb='xxl'
                        variant='container'
                    >
                        <Heading
                            as='h2'
                            variant='h1'
                        >
                            {post.title}
                        </Heading>
                        {renderHTML(post.content.description || '')}
                    </Box>
                    <Feed
                        options={{
                            borderColor: 'black',
                            heading: 'Related vehicles',
                            spacing: {
                                bottom: 'lg',
                                left: 'md',
                                right: 'md',
                                top: 'lg',
                            },
                            type: 'carousel',
                            variation: 'filmstrip',
                        }}
                    />
                </Layout>
            )}
        </>
    )
}

export default PostDetails

export const query = graphql`
    query ($slug: String) {
        allUser {
            nodes {
                uid
                first_name
                last_name
            }
        }
        post(slug: { eq: $slug }) {
            title
            categories
            date_published
            published_by
            media {
                set {
                    filename
                    filepath
                    media_type
                    public_id
                }
                gallery {
                    images {
                        filename
                        filepath
                        media_type
                        public_id
                    }
                    videos {
                        filename
                        filepath
                        media_type
                        public_id
                    }
                }
            }
            visibility
            slug
            content {
                excerpt
                keypoints
                description
                # Modules at the top level
                modules
            }
        }
        allCollection(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    media {
                        set {
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_published
                    published_by
                    slug
                    title
                    item_id
                    categories
                    content {
                        description
                        excerpt
                    }
                }
            }
        }
        allPost(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    categories
                    content {
                        description
                        excerpt
                    }
                    media {
                        set {
                            caption
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_added
                    slug
                    title
                    date_published
                }
            }
        }
        allPage(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    content {
                        description
                        excerpt
                    }
                    media {
                        set {
                            caption
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_added
                    slug
                    title
                    date_published
                }
            }
        }
    }
`
